import React, { useEffect, useState } from 'react';
import { AlertTriangle } from 'lucide-react';
export function UpsellCountdown() {
  const [timeLeft, setTimeLeft] = useState(5 * 60); // 5 minutes in seconds
  useEffect(() => {
    const timer = setInterval(() => {
      setTimeLeft(prev => {
        if (prev <= 1) {
          clearInterval(timer);
          return 0;
        }
        return prev - 1;
      });
    }, 1000);
    return () => clearInterval(timer);
  }, []);
  const minutes = Math.floor(timeLeft / 60);
  const seconds = timeLeft % 60;
  return <div className="fixed top-0 left-0 right-0 z-50 bg-[#E65100] text-white py-2 px-4 shadow-md" data-id="element-447">
      <div className="max-w-4xl mx-auto flex flex-col md:flex-row items-center justify-center gap-2 md:gap-4 text-center" data-id="element-448">
        <div className="flex items-center gap-2 font-bold text-sm md:text-base" data-id="element-449">
          <AlertTriangle className="w-5 h-5 animate-pulse" data-id="element-450" />
          <span data-id="element-451">
            ATENCIÓN: No abandones esta página. Aprovecha esta oportunidad única
            antes de que el tiempo se acabe.
          </span>
        </div>
        <div className="bg-white/20 px-3 py-1 rounded-lg font-black text-lg tracking-wider tabular-nums" data-id="element-452">
          {minutes.toString().padStart(2, '0')}:
          {seconds.toString().padStart(2, '0')}
        </div>
      </div>
    </div>;
}